import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'network-float-action',
  templateUrl: './network-float-action.component.html',
  styleUrl: './network-float-action.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NetworkFloatActionComponent {
  @Input() selectedItems: any[] = [];
  @Input() componentType: 'network' | 'suggestions' = 'network'; // To differentiate between network and suggestions usage
  @Input() isFromNetworkSetup: boolean = false;
  @Output() actionClick = new EventEmitter<{ action: string; items: any[] }>();

  onActionClick(action: string) {
    this.actionClick.emit({
      action: action,
      items: this.selectedItems,
    });
  }
}
